<template>
    <ve-table
        :table-data="data"
        :cell-style-option="cellStyleOption"
        :cellSelectionOption="cellSelectionOption"
        :border-around="false"
        :border-x="true"
        :border-y="false"
        :sort-option="sortOption"
        :virtual-scroll-option="virtualScrollOption"
        row-key-field-name="rowKey"
        class="virtual-scroll-table"
        v-bind="$attrs"
        fixed-header
    />
</template>
<script>
    import tableHelper from 'components/user/organizationreport/tables/helpers/table-helper'
    export default {
        name: 'virtual-scroll-table',
        mixins: [ tableHelper ],
        props: {
            data: {
                type: Array
            }
        },
        data () {
            return {
                virtualScrollOption: {
                    enable: true,
                    bufferScale: 10
                }
            }
        }
    }
</script>

<style lang="scss">
    .virtual-scroll-table {
        .table-header-cell {
            background: $champagne !important;
            border-bottom: 2px solid $silver_chalice !important;
            color: $emperor !important;
            font-family: Nunito-ExtraBold, sans-serif;
            font-size: 1.4rem;
            height: 39px;
            white-space: nowrap
        }

        .table-row-cell {
            background: $old_lace !important;
            border-bottom: 1px solid $silver_chalice !important;
        }

        .ve-table {
            .ve-table-header-tr {
                background: $champagne;
            }
            .ve-table-header-th {
                vertical-align: baseline;
            }

            .ve-table-content {
                margin: 0 0 30px;
            }

            .ve-table-sort-icon.active {
                color: $mine_shaft !important;
            }

            tr.ve-table-body-tr {
                height: 48px !important;
            }

            td.ve-table-body-td {
                padding: 6px 10px !important;
            }

            .iconfont-vet {
                font-family: 'iconfont-vet' !important;
            }
        }
    }
</style>
